import { createPortal } from "react-dom";
import React from "react";

const TooltipPortal: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    return createPortal(children, document.body);
};

export default TooltipPortal;
